import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/project/importer/projectImporterActions';

export default importerReducers(actions);
